export default class NewTag {
  id?: number
  category: string | null
  value: string
  isEditable: boolean

  constructor(category: string | null, value: string, isEditable: boolean, id?: number) {
    this.value = value
    this.category = category
    this.isEditable = isEditable
    this.id = id
  }

  static fromJson(json): NewTag {
    return new NewTag(json.category || null, json.value, json.is_editable, json.id || undefined)
  }

  static toObject(obj): NewTag {
    if (obj instanceof NewTag) {
      return obj
    }
    return new NewTag(obj.category || null, obj.value, obj.isEditable, obj.id || undefined)
  }

  get toDisplayString(): string {
    return this.category ? `${this.category}:${this.value}` : this.value
  }
}
